import { Box, Button, Container, Heading, Stack, Text } from '@chakra-ui/react'
import Link from 'next/link'

export const SubmitYourRideCallout = () => {
  return (
    <>
      <Box
        backgroundColor='blue.900'
        backgroundImage='url(/img/callout-background.webp)'
        backgroundSize='cover'>
        <Container
          textAlign='center'
          py={40}
          maxW='2xl'
          style={{ textWrap: 'balance' } as React.CSSProperties}>
          <Stack spacing={8}>
            <Stack>
              <Heading
                color='blue.500'
                fontSize='5xl'
                fontWeight='bold'
                textAlign='center'>
                Are you working on a project like this?
              </Heading>
              <Text color='white'>
                Share your project with the community, add it to{' '}
                <Link href='/nation/map/projects'>
                  <span style={{ textDecoration: 'underline' }}>
                    the&nbsp;map
                  </span>
                </Link>
                , and you could be on the next Member Spotlight.
              </Text>
            </Stack>
            <div>
              <Link href='/membership' passHref legacyBehavior>
                <Button as='a' colorScheme='red'>
                  Join Deboss Nation
                </Button>
              </Link>
            </div>
          </Stack>
        </Container>
      </Box>
    </>
  )
}
